// SectionRenderer
//
// HomeSection'dan gelen Section nesnelerini doğru component'e yönlendirir.
// Kendi state/event/hook'u yok; "use client" taşımıyor ama client olan
// HomeSection'dan import edildiği için client grafiğinde derleniyor.
// Sunucuya özel hiçbir API kullanmadığından bu güvenli.
//
// Bu noktaya yalnızca HomeSectionLoader'ın özel işlemediği
// section'lar ulaşır: tabs, carousel, auto-grid.
//
// shouldSkipSection: HomeSectionLoader zaten hero/categories/brands/
// instagram/manual-grid'i önceden yönlendirdiği için buraya ulaşmaz;
// ancak beklenmedik API değişikliklerine karşı defense-in-depth olarak
// bırakılmıştır.

import { Section } from "@/app/lib/features/home/home.types";
import ProductSection from "./ProductSection";
import DiscoverProductsSection from "./DiscoverProductsSection";
import { shouldSkipSection } from "@/app/constants/sectionConfig";

interface SectionRendererProps {
  section: Section;
  isFirst?: boolean;
}

const SectionRenderer = ({ section, isFirst }: SectionRendererProps) => {
  // Defense-in-depth: özel display type'lar buraya ulaşmamalı ama
  // API değişikliği durumuna karşı kontrol ediyoruz.
  if (shouldSkipSection(section)) return null;

  // ── Tabs: DiscoverProductsSection ─────────────────────────────────────────
  if (section.display_type === "tabs") {
    if (!section.items?.length) return null;

    const hasProducts = section.items.some(
      (item) => item.products && item.products.length > 0,
    );
    if (!hasProducts) return null;

    return <DiscoverProductsSection section={section} isFirst={isFirst} />;
  }

  // ── Carousel / auto-grid: ProductSection ──────────────────────────────────
  const isProductSection =
    (section.display_type === "carousel" || section.display_type === "grid") &&
    section.content_source !== "manual";

  if (isProductSection) {
    if (!section.products?.length) return null;

    return (
      <ProductSection
        sectionId={section.id}
        title={section.title}
        icon={section.style?.icon}
        products={section.products}
        linkUrl={section.link?.url}
        linkText={section.link?.text}
        countdown={section.countdown}
        viewAllSlug={`/${section.slug}`}
        // İlk section için ilk 3 ürün kartına LCP priority ver.
        priorityCount={isFirst ? 3 : 0}
      />
    );
  }

  // Tanınmayan section tipi — sessizce atla
  return null;
};

export default SectionRenderer;